import { Component } from 'react'
import _ from 'lodash'
import cx from 'classnames'

import update from 'immutability-helper'
import styles from './index.css'

import { AntdCheckbox, FormError } from '../../../../../../Common/Form'
import withAttributeTransient from '../../../../../Common/HOC/withAttributeTransient'
import {
  hasDuplicateSpec,
  makeItemOptions,
  makeCustomItemOption,
  getSlicedSpecItems,
  getMaxSpecItemLen
} from '../../../../../Common/ProposalForm/Shared/util'
import { Toast, Button, MenuSelect, ItemTag } from '@vzmi/shp_shared_compo'
import { customAttributeInputLengthFormatter } from '../../../../../Common/ProposalForm/Shared/formatters'
import SpecSettingModalContainer from '../SpecSettingModal/SpecSettingModalContainer'
import TextInputTag from '../../../../../../Common/TextInputTag/TextInputTag'
import { removeNonPrintableCharParser } from '../../../../../../../lib/parser'
import { filterHtmlTag, normalizeAll } from '../../../../../Common/ProposalForm/Shared/normalizers'

const menuSelectCustomInputNormalizer = normalizeAll(removeNonPrintableCharParser, filterHtmlTag)

const getlengthUsedByFirstLayer = (spec) => _.get(spec, 'selectedItemOptions', [])
  .map(item => item.value)
  .reduce((longestValueLength, itemValue = '') => _.max([itemValue.length, longestValueLength]), 0) + 1

class SpecMenuSelector extends Component {
  state = {
    visible: false,
    /** 第一層屬性用掉多少字數長度 */
    lengthUsedByFirstLayer: 0
  }

  showModal = () => {
    this.setState({
      visible: true
    })
  }

  handleOk = (e) => {
    this.setState({
      visible: false
    })
  }

  handleCancel = (e) => {
    this.setState({
      visible: false
    })
  }

  componentDidMount () {
    const { transientModel } = this.props
    const spec = _.get(transientModel, 'spec', [])
    const firstSpec = _.get(spec, '[0]', {})
    const lengthUsedByFirstLayer = getlengthUsedByFirstLayer(firstSpec)

    this.setState(() => ({ lengthUsedByFirstLayer }))
  }

  componentDidUpdate (prevProps) {
    const { transientModel } = this.props
    const spec = _.get(transientModel, 'spec', [])
    const firstSpec = _.get(spec, '[0]', {})
    if (spec.length !== _.get(prevProps, 'transientModel.spec.length', 0)) {
      this.syncSpecLayerItems(spec)
    }

    const prevSpec = _.get(prevProps, 'transientModel.spec[0]', [])
    /** 計算第一層屬性用掉多少字數，最後 +1 因為要算 - 號 */
    const lengthUsedByFirstLayer = getlengthUsedByFirstLayer(firstSpec)
    const prevPropsLengthUsedByFirstLayer = getlengthUsedByFirstLayer(prevSpec)

    if (lengthUsedByFirstLayer !== prevPropsLengthUsedByFirstLayer) {
      this.setState(() => ({ lengthUsedByFirstLayer }))
    }
  }

  syncSpecLayerItems = (nextSpec) => {
    const { level, transientField } = this.props
    const specLength = _.get(nextSpec, 'length', 0)
    const firstSpec = _.get(nextSpec, '[0]', {})
    const firstSelectedItemOptions = _.get(firstSpec, 'selectedItemOptions', [])
    if (specLength > 0) {
      const slicedFirstSelectedItemOptions = getSlicedSpecItems(firstSelectedItemOptions, specLength, level)
      if (level === 1 && firstSelectedItemOptions.length !== slicedFirstSelectedItemOptions.length) {
        _.set(firstSpec, 'selectedItemOptions', slicedFirstSelectedItemOptions)
        this.props.triggerFieldChange(`${transientField}.spec[0]`, firstSpec)
      } else if (level === 2) {
        const secondSpec = _.get(nextSpec, '[1]', {})
        const secondSelectedItemOptions = _.get(secondSpec, 'selectedItemOptions', [])
        const slicedSecondSelectedItemOptions = getSlicedSpecItems(secondSelectedItemOptions, specLength, level)
        if (secondSpec.length !== slicedSecondSelectedItemOptions.length) {
          _.set(secondSpec, 'selectedItemOptions', slicedSecondSelectedItemOptions)
          this.props.triggerFieldChange(`${transientField}.spec[1]`, secondSpec)
        }
      }
    }
  }

  getTransientSpecErrors = () => {
    const { transientErrors } = this.props
    return _.get(transientErrors, 'spec', [])
  }

  handleFieldChange = (value) => {
    const { input } = this.props
    const { onChange, onBlur } = input
    onChange(value)
    onBlur(value)
  }

  getMenuSelectValue = () => {
    const { input } = this.props
    const selectedOption = _.get(input, 'value.selectedOption', {})
    const isEmptySelectedOption = _.isEmpty(selectedOption)

    return isEmptySelectedOption
      ? []
      : [selectedOption.displayName || selectedOption.value]
  }

  removeSpecItem = (removeOption) => {
    const { input } = this.props
    const { value = {} } = input
    const copiedArr = [...value.selectedItemOptions]
    _.pullAllBy(copiedArr, [removeOption], 'key')
    const localState = update(
      value, {
        selectedItemOptions: { $set: copiedArr }
      }
    )
    this.handleFieldChange(_.assign({}, value, localState))
  }

  getSelectedItemOptionsTags = selectedItemOptions => {
    const { readOnly } = this.props

    return _.map(
      selectedItemOptions,
      (option, idx) => {
        const {
          key,
          displayName,
          value
        } = option

        const tagKey = `${key}__${idx}`
        const removeTheOption = () => this.removeSpecItem(option, selectedItemOptions)

        return (
          <ItemTag
            key={tagKey}
            color='#5478fc'
            onEdit={this.showModal}
            closable={!readOnly}
            editable={!readOnly}
            onClose={removeTheOption}
          >
            {displayName || value}
          </ItemTag>
        )
      }
    )
  }

  getAttributeOptions = () => {
    const { specLength, specData, level, fields, getAttributeOptions } = this.props
    return getAttributeOptions({ specLength, specData, level, fields })
  }

  getAttributeItemOptions = (selectedOption) => {
    return this.props.getAttributeItemOptions(selectedOption)
  }

  handleAttrMenuSelect = (selectedOption, menuIndex) => {
    const { input, specData } = this.props
    const { value = {} } = input
    const selectOptVal = _.get(selectedOption, 'value')
    let selectedItemOptions = []
    if (selectOptVal && _.get(specData, 'selectedOption.value') === selectOptVal) {
      selectedItemOptions = _.get(specData, 'selectedItemOptions') || []
    }
    const localState = update(
      value, {
        selectedOption: { $set: selectedOption },
        selectedItemOptions: { $set: selectedItemOptions },
        customInput: { $set: selectedOption.value === value.customInput ? value.customInput : null }
      }
    )
    this.handleFieldChange(_.assign({}, value, localState))
  }

  handleSpecItemMenuSelect = (updateOption, menuIndex) => {
    // 最多兩層，第一層和第二層屬性不可相同
    // 第二層屬性列表隱藏第一層已選擇之屬性
    // 每一層之屬性項目名稱不可相同
    const { level } = this.props
    const specLength = _.get(this.props, 'transientModel.spec.length', 0)
    // be compatible with array parameter
    const updateOptions = _.filter(
      _.isArray(updateOption) ? updateOption : [updateOption],
      (opt = {}) => !_.isEmpty(opt.value)
    )
    if (!_.isEmpty(updateOptions)) {
      const { value = {} } = this.props.input
      const { selectedItemOptions = [] } = value
      const localSelectedItemOptions = makeItemOptions([
        ...selectedItemOptions,
        ...getSlicedSpecItems(updateOptions, specLength, level)
      ])
      if (hasDuplicateSpec(localSelectedItemOptions)) {
        Toast.warning('項目名稱不可相同，請調整項目名稱')
      }
      const localState = update(
        value, {
          selectedItemOptions: { $set: localSelectedItemOptions }
        }
      )
      this.handleFieldChange(_.assign({}, value, localState))
    }
  }

  handleCustomInputSubmit = (inputValue, foundInputOption) => {
    const { value = {} } = this.props.input
    const formatInputValue = removeNonPrintableCharParser(customAttributeInputLengthFormatter(inputValue))
    const localState = update(
      value, {
        customInput: { $set: formatInputValue }
      }
    )
    this.handleFieldChange(_.assign({}, value, localState))
    setImmediate(() => {
      this.handleAttrMenuSelect(
        foundInputOption ||
        /**
         * 自訂屬性要主動設定 cluster.hasOTHER 為 true,
         * 這樣下拉項目選單才會有 '自訂項目' 可以用
         */
        {
          label: formatInputValue,
          value: formatInputValue,
          cluster: {
            hasOTHER: true
          }
        })
    })
  }

  // 若是自訂屬性項目則values需填寫其他且加上DisplayName
  handleCustomItemInputSubmit = (inputValue, foundInputOption) => {
    setImmediate(() => {
      const localValue = menuSelectCustomInputNormalizer(inputValue)
      this.handleSpecItemMenuSelect(
        foundInputOption || makeCustomItemOption(localValue)
      )
    })
  }

  /**
   * @param {Array.<String>} tags
   */
  handleCustomItemTagsSubmit = (tags = []) => {
    setImmediate(() => {
      const normalizedTags = tags.map(menuSelectCustomInputNormalizer)
      this.handleSpecItemMenuSelect(normalizedTags.map(makeCustomItemOption))
    })
  }

  handleSettingFormSubmit = (formValues) => {
    const { productName, specItems } = formValues
    this.props.triggerFieldChange('product.name', productName)
    const { value = {} } = this.props.input
    const localState = update(
      value, {
        selectedItemOptions: { $set: makeItemOptions(_.map(specItems, item => ({ ...item }))) }
      }
    )
    this.handleFieldChange(_.assign({}, value, localState))
  }

  /**
   * 除了 constraint.type === 'text' 以外的 attribute option，
   * values 裡面必須有 ”自訂“ 才可以有 customInput
   *
   * @see https://jira.ouroath.com/browse/APACSMDESK-33566
   */
  getEnableMenuSelectCustomInput = selectedOption => {
    const isTextTypeInSelectedOption = _.get(selectedOption, 'cluster.constraints.type', '') === 'text'
    const hasOtherAttrInSelectedOption = _.get(selectedOption, 'cluster.hasOTHER', false)
    return isTextTypeInSelectedOption || hasOtherAttrInSelectedOption
  }

  /**
   * 將該 spec 從 redux fields 中清除，
   * 目前只有第二層可以 remove
   */
  removeField = () => {
    const {
      fields,
      specIndex
    } = this.props

    fields.remove(specIndex)
  }

  render () {
    const { lengthUsedByFirstLayer } = this.state
    const {
      input,
      className,
      readOnly,
      productName,
      specIndex,
      level,
      showExpiringAddon,
      proposalType
    } = this.props
    const specLength = _.get(this.props, 'transientModel.spec.length', 0)
    const specItemMaxLen = getMaxSpecItemLen(specLength, level)

    const { value = {} } = input
    const {
      customInput,
      selectedOption,
      selectedItemOptions
    } = value

    const isInitialEmpty = _.isEmpty(value)
    const selectedOptionConstraintType = _.get(selectedOption, 'cluster.constraints.type', null)
    const isSelectedOptionTextType = selectedOptionConstraintType === 'text'
    /**
     * 自訂的 `商品屬性` ，
     * option 裡面不會有 constraint.type
     * */
    const isSelectedOptionCustomInput = _.isNil(selectedOptionConstraintType)

    const enableMenuSelectCustomInput = this.getEnableMenuSelectCustomInput(selectedOption)

    const selectedTags = this.getSelectedItemOptionsTags(selectedItemOptions)

    // 左邊的商品屬性 options, 父層
    const attributeOptions = this.getAttributeOptions()
    // 右邊的商品屬性項目，子層
    const attributeItemOptions = this.getAttributeItemOptions(selectedOption)

    const isShowFormError = _.get(this.props, 'meta.touched')

    const menuSelectValue = this.getMenuSelectValue()
    const isDisabledMenuSelect = readOnly || _.isEmpty(menuSelectValue)

    const showTextTagInputField = selectedTags.length < specItemMaxLen

    const transientSpecErrors = this.getTransientSpecErrors()

    return (
      <div
        className={cx(styles.SpecMenuSelector, className)}
        data-role={`spec-menu-selector-${specIndex + 1}`}
      >
        {/* 商品屬性，齒輪icon設定點擊後會出現 modal 那一塊 */}
        {!_.isEmpty(selectedItemOptions) && !readOnly && (
          <>
            <div
              key='button'
              className={cx(styles.settingButton, styles.paddingRight)}
            >
              <Button
                type='button'
                link
                size='medium'
                data-role='setting-attribute-button'
                iconType='ec-settings'
                className={styles.linkButton}
                onClick={() => this.showModal()}
              >
                設定
              </Button>
            </div>
            <SpecSettingModalContainer
              key='modal'
              centered
              visible={this.state.visible}
              onOk={this.handleOk}
              width={680}
              onCancel={this.handleCancel}
              submitForm={this.handleSettingFormSubmit}
              proposalType={proposalType}
              defaultFormData={{
                lengthUsedByFirstLayer,
                showExpiringAddon,
                level,
                productName,
                specItems: selectedItemOptions
              }}
            />
          </>
        )}
        {/* 商品屬性，有選項，第一層第二層選單 */}
        <div
          key='attrBlock'
          className={styles.attributeSelectBlock}
        >
          <MenuSelect
            key='attrSelect'
            value={menuSelectValue}
            placeholder='設定屬性'
            menuInputPlaceholder='搜尋關鍵字'
            enableCustomInput
            enableMenuFilter
            editableCustomInput
            customInput={customInput}
            customInputPlaceholder='請輸入屬性'
            customInputButtonText='自訂屬性'
            normalizeCustomInput={menuSelectCustomInputNormalizer}
            onCustomInputSubmit={this.handleCustomInputSubmit}
            onSelect={this.handleAttrMenuSelect}
            disabled={readOnly}
            className={styles.attributeSelect}
            popupClassName={`${styles.attributeSelectPopup} spec-menu-select-${specIndex + 1}`}
            options={attributeOptions}
          />
          <FormError
            key='attrBlockError'
            showFormError={isShowFormError}
            error={_.get(transientSpecErrors, `[${specIndex}].selectedOption`)}
          />
        </div>
        <div
          key='attrItemBlock'
          className={
            cx(styles.attributeItemSelectBlock,
              {
                [styles.paddingRight]: level === 1
              })
          }
        >
          {
            (!isInitialEmpty && (isSelectedOptionTextType || isSelectedOptionCustomInput))
              ? (
                <TextInputTag
                  showTextTagInputField={showTextTagInputField}
                  selectedTags={selectedTags}
                  disabled={isDisabledMenuSelect}
                  onSubmitTag={this.handleCustomItemTagsSubmit}
                />
              )
              : (
                <MenuSelect
                  key='attrItem'
                  ref={r => (this.attrItemMenuSelect = r)}
                  placeholder='選擇單筆或多筆項目'
                  inputPickerValue={selectedTags}
                  menuInputPlaceholder='搜尋關鍵字'
                  enableCustomInput={enableMenuSelectCustomInput}
                  enableMenuFilter
                  customInputPlaceholder='請輸入項目'
                  customInputButtonText='自訂項目'
                  onCustomInputSubmit={this.handleCustomItemInputSubmit}
                  disabled={isDisabledMenuSelect}
                  className={styles.attributeItemSelect}
                  popupClassName={`${styles.attributeItemSelectPopup} spec-item-menu-select-${specIndex + 1}`}
                  options={attributeItemOptions}
                  onSelect={this.handleSpecItemMenuSelect}
                  optionRenderer={(option, menuIndex) => {
                    return (
                      <AntdCheckbox
                        data-role='attribute-item-checkbox'
                        type='plus'
                      >
                        {option.label}
                      </AntdCheckbox>
                    )
                  }}
                  closeOnSelect={false}
                  closeOnCustomInputSubmit={false}
                />
              )
          }
          <FormError
            key='itemError'
            showFormError={isShowFormError}
            error={_.get(transientSpecErrors, `[${specIndex}].selectedItemOptions`)}
          />
        </div>
        {
          !readOnly && level === 2 && (
            <Button
              link
              iconType='delete'
              buttonType='outline'
              data-role='delete-attribute-button'
              className={styles.deleteButton}
              onClick={this.removeField}
            />
          )
        }
      </div>
    )
  }
}

const SpecMenuSelectorField = withAttributeTransient(SpecMenuSelector)

export default SpecMenuSelectorField
